import { useState } from "react";

export default function BorderSelect({ top, bottom, left, right, onToggle }) {
	const [topToggle, setTopToggle] = useState(top);
	const [bottomToggle, setBottomToggle] = useState(bottom);
	const [leftToggle, setLeftToggle] = useState(left);
	const [rightToggle, setRightToggle] = useState(right);

	const handleBorderToggle = (side) => {
		// top bottom left right
		let t = topToggle;
		let b = bottomToggle;
		let l = leftToggle;
		let r = rightToggle;

		if (side === "top") {
			t = topToggle === "1" ? "0" : "1";
			setTopToggle(t);
		} else if (side === "bottom") {
			b = bottomToggle === "1" ? "0" : "1";
			setBottomToggle(b);
		} else if (side === "left") {
			l = leftToggle === "1" ? "0" : "1";
			setLeftToggle(l);
		} else if (side === "right") {
			r = rightToggle === "1" ? "0" : "1";
			setRightToggle(r);
		}

		return onToggle(`${t}${b}${l}${r}`);
	};

	return (
		<div className="flex flex-col mt-3 w-14">
			<button
				onClick={() => {
					handleBorderToggle("top");
				}}
				className={`w-14 h-3 cursor-pointer focus:outline-none
							${
								topToggle === "1"
									? "bg-main-500 hover:bg-main-400"
									: "bg-gray-700 hover:bg-gray-600"
							}
			`}
			></button>
			<div className="flex justify-between">
				<button
					onClick={() => {
						handleBorderToggle("left");
					}}
					className={`w-3 h-4 cursor-pointer focus:outline-none
							${
								leftToggle === "1"
									? "bg-main-500 hover:bg-main-400"
									: "bg-gray-700 hover:bg-gray-600"
							}					
					`}
				></button>
				<button
					onClick={() => {
						handleBorderToggle("right");
					}}
					className={`w-3 h-4 cursor-pointer focus:outline-none
							${
								rightToggle === "1"
									? "bg-main-500 hover:bg-main-400"
									: "bg-gray-700 hover:bg-gray-600"
							}					
					`}
				></button>
			</div>
			<button
				onClick={() => {
					handleBorderToggle("bottom");
				}}
				className={`w-14 h-3 cursor-pointer focus:outline-none
						${
							bottomToggle === "1"
								? "bg-main-500 hover:bg-main-400"
								: "bg-gray-700 hover:bg-gray-600"
						}
				`}
			></button>
		</div>
	);
}
